import React from 'react';
import Grid from "@material-ui/core/Grid";
import TeamMembers from "./teamMembers";
import TeamInvitations from "./teamInvitations";

const TeamManagement = (props) => {
    return (
        <Grid container>
            <Grid item xs={12}>
                <TeamMembers {...props}/>
            </Grid>
            <Grid item xs={12} style={{marginTop: 20,}}>
                <TeamInvitations {...props}/>
            </Grid>
        </Grid>
    )
};

export default TeamManagement
